import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import ChevronRight16 from '@carbon/icons-react/es/chevron--right/16';
import { keyBy } from 'lodash';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectBulkMergeResult } from 'api/project';
import { Alert } from 'components/atoms/alert';
import { Button } from 'components/atoms/button';
import { PageLoading } from 'components/atoms/loading';
import { useProjectTemplates } from 'queries';
import { columns } from './columns';
import { StyledTable } from './styled';
import { toTableDataSource } from './utils';

interface Props {
  data?: ProjectBulkMergeResult[];
}

export const StepTwo: FC<Props> = ({ data }) => {
  const { data: templates, isLoading } = useProjectTemplates();

  return isLoading ? (
    <PageLoading />
  ) : (
    <>
      <Alert
        showIcon
        type="info"
        message={<FormattedMessage id="projects.phase.import.preview.alert" />}
      />
      <br />
      <StyledTable
        size="small"
        columns={columns}
        dataSource={toTableDataSource(keyBy(templates ?? [], 'templateId'))(
          data,
        )}
        pagination={false}
        expandable={{
          defaultExpandAllRows: false,
          indentSize: 32,
          expandIcon: ({ expanded, onExpand, record }) =>
            record.children && record.children.length > 0 ? (
              <Button
                size="small"
                type="text"
                icon={expanded ? <ChevronDown16 /> : <ChevronRight16 />}
                onClick={(e) => onExpand(record, e)}
              />
            ) : (
              <Button size="small" type="text" style={{ width: '32px' }} />
            ),
        }}
      />
    </>
  );
};
